import React from "react";
import { Flex, IconTick, } from "@catchoftheday/cg-components";
import { styled, themeGet } from "@catchoftheday/theme";
const ListItemContainer = styled(Flex) `
  ${(props) => `justify-content: ${props.isSelectedLocation ? "space-between" : "flex-start"};
      background-color: ${props.isHighlighted ? themeGet("colors.ui.dropDownBg")(props) : "white"};
      color: ${props.isErrorMessage
    ? themeGet("colors.error")(props)
    : props.isHighlighted || props.isSelectedLocation
        ? themeGet("colors.ui.dropDownText")(props)
        : themeGet("colors.text")(props)};
    `}
  padding: 10px;
  &:hover {
    color: ${(props) => props.isErrorMessage
    ? themeGet("colors.error")(props)
    : themeGet("colors.ui.dropDownText")(props)};
    background-color: ${(props) => props.isErrorMessage ? "white" : themeGet("colors.ui.dropDownBg")};
  }
`;
export const renderListItem = ({ itemData, isHighlighted }) => {
    const isErrorMessage = itemData.value?.isErrorMessage;
    const isSelectedLocation = itemData.value?.isSelectedLocation;
    return (<ListItemContainer isHighlighted={isHighlighted && !isErrorMessage && !isSelectedLocation} fontWeight="light" isErrorMessage={isErrorMessage || false} isSelectedLocation={isSelectedLocation || false}>
      {itemData.title}
      {isSelectedLocation && (<IconTick width="10px" height="17px" aria-hidden="true" data-testid="selected-location-tick"/>)}
    </ListItemContainer>);
};
